import { axiosInstance } from "@/config/axiosInstance";

// ? Change Status of TODO
export const calculateSalary =
  (employeeKey: string) =>
  (data: {
    notes: string;
    period: {
      start: Date;
      end: Date;
    };
  }) =>
    axiosInstance
      .post<{
        message: string;
        salary: {
          _id: string;
          createdAt: string | Date;
          netPay: number;
          notes: string;
          totalDeductions: number;
          totalEarnings: number;
          period: {
            start: string | Date;
            end: string | Date;
          };
          components: {
            _id: string;
            amount: number;
            name: string;
            type: string;
          }[];
        };
      }>(`/salary/calc`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Change Status of TODO
export const createDateSheetClaim =
  (employeeKey: string) =>
  (data: {
    notes?: string;
    monthName: string;
    year: number;
    present: number;
    absent: number;
    halfDay?: number;
    paidLeave: number;
    unpaidLeave: number;
  }) =>
    axiosInstance
      .post<{
        message: string;
        sheet: any;
      }>(`/salary/create-datesheet`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
